import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-domains" id="module-storage-domains"></a>
    <h1 {...{
      "id": "requireuxpstoragedomains"
    }}>{`require('uxp').storage.domains`}</h1>
    <a name="new-module-storage-domains-new" id="new-module-storage-domains-new"></a>
    <h2 {...{
      "id": "domains"
    }}>{`domains()`}</h2>
    <p>{`Common locations that we can use when displaying a file picker.`}</p>
    <a name="module-storage-domains-userdesktop" id="module-storage-domains-userdesktop"></a>
    <h2 {...{
      "id": "userdesktop--symbol"
    }}>{`userDesktop : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The user's desktop folder`}</p>
    <a name="module-storage-domains-userdocuments" id="module-storage-domains-userdocuments"></a>
    <h2 {...{
      "id": "userdocuments--symbol"
    }}>{`userDocuments : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The user's documents folder`}</p>
    <a name="module-storage-domains-userpictures" id="module-storage-domains-userpictures"></a>
    <h2 {...{
      "id": "userpictures--symbol"
    }}>{`userPictures : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The user's pictures folder or library`}</p>
    <a name="module-storage-domains-uservideos" id="module-storage-domains-uservideos"></a>
    <h2 {...{
      "id": "uservideos--symbol"
    }}>{`userVideos : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The user's videos / movies folder or library`}</p>
    <a name="module-storage-domains-usermusic" id="module-storage-domains-usermusic"></a>
    <h2 {...{
      "id": "usermusic--symbol"
    }}>{`userMusic : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The user's music folder or library`}</p>
    <a name="module-storage-domains-applocaldata" id="module-storage-domains-applocaldata"></a>
    <h2 {...{
      "id": "applocaldata--symbol"
    }}>{`appLocalData : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Local application data`}</p>
    <a name="module-storage-domains-applocallibrary" id="module-storage-domains-applocallibrary"></a>
    <h2 {...{
      "id": "applocallibrary--symbol"
    }}>{`appLocalLibrary : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Local application library`}</p>
    <a name="module-storage-domains-applocalcache" id="module-storage-domains-applocalcache"></a>
    <h2 {...{
      "id": "applocalcache--symbol"
    }}>{`appLocalCache : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Local application cache directory (persistence not guaranteed)`}</p>
    <a name="module-storage-domains-applocalshared" id="module-storage-domains-applocalshared"></a>
    <h2 {...{
      "id": "applocalshared--symbol"
    }}>{`appLocalShared : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Local application shared data folder`}</p>
    <a name="module-storage-domains-applocaltemporary" id="module-storage-domains-applocaltemporary"></a>
    <h2 {...{
      "id": "applocaltemporary--symbol"
    }}>{`appLocalTemporary : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Local temporary directory`}</p>
    <a name="module-storage-domains-approamingdata" id="module-storage-domains-approamingdata"></a>
    <h2 {...{
      "id": "approamingdata--symbol"
    }}>{`appRoamingData : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Roaming application data`}</p>
    <a name="module-storage-domains-approaminglibrary" id="module-storage-domains-approaminglibrary"></a>
    <h2 {...{
      "id": "approaminglibrary--symbol"
    }}>{`appRoamingLibrary : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Roaming application library data`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      